module.exports = __webpack_public_path__ + "img/sld_mfm_t1_dark.d4950da3.svg";